import React from 'react';
import { Button } from '@/components/ui/button';

export default function IntroVideo({ onComplete }) {
  const handleStart = () => {
    // Mark intro as shown in session
    sessionStorage.setItem('intro_shown', 'true');
    onComplete();
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-white overflow-y-auto">
      {/* Welcome Screen - GDIOT Brand */}
      <div className="min-h-full w-full flex flex-col items-center justify-center bg-white px-4 py-8 sm:px-6">
        {/* Subtle Background Pattern */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full opacity-[0.03]">
            <div className="absolute top-10 left-10 w-96 h-96 bg-primary-blue rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-20 w-80 h-80 bg-[#4AAEFF] rounded-full blur-3xl"></div>
          </div>
        </div>

        {/* Main Content - Better mobile spacing */}
        <div className="relative z-10 text-center space-y-4 sm:space-y-6 max-w-4xl w-full">
          {/* GDIOT Logo - Responsive sizing */}
          <div className="animate-fade-in flex justify-center mb-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_eduboard-23/artifacts/rlkpswoq_GDIOT%20LOGO%201024%20X%201024.png" 
              alt="GDIOT Logo" 
              className="w-40 h-40 sm:w-56 sm:h-56 md:w-64 md:h-64 object-contain drop-shadow-2xl"
            />
          </div>

          {/* Main Greeting - Better mobile text sizing */}
          <div className="space-y-2 sm:space-y-3 animate-fade-in delay-300">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#0F1C2E] leading-tight px-2">
              Hello Genius Idiots!
            </h1>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-primary-blue flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 px-2">
              <span>Welcome to the Family</span>
              <span className="text-4xl sm:text-5xl animate-pulse">❤️</span>
            </h2>
          </div>

          {/* Primary Action Button - Touch-friendly sizing */}
          <div className="animate-fade-in delay-600 pt-4 sm:pt-6 pb-4">
            <Button
              onClick={handleStart}
              size="lg"
              className="bg-primary-blue hover:bg-[#1873CC] text-white font-bold text-lg sm:text-xl md:text-2xl px-8 py-6 sm:px-12 sm:py-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 w-full max-w-xs sm:max-w-none sm:w-auto"
            >
              Start Learning & Grow 🚀
            </Button>
          </div>

          {/* Bottom Inspirational Quote - Better mobile layout */}
          <div className="animate-fade-in delay-900 pt-3 sm:pt-4 pb-4">
            <div className="max-w-4xl mx-auto px-2">
              {/* Decorative Top Line */}
              <div className="flex items-center justify-center mb-2 sm:mb-3">
                <div className="w-16 sm:w-24 h-[2px] bg-gradient-to-r from-transparent via-[#A5A5A5] to-[#A5A5A5] rounded-full"></div>
                <div className="mx-2 sm:mx-4 w-2 h-2 bg-[#A5A5A5] rounded-full"></div>
                <div className="w-16 sm:w-24 h-[2px] bg-gradient-to-r from-[#A5A5A5] via-[#A5A5A5] to-transparent rounded-full"></div>
              </div>
              
              {/* Quote - Responsive text that wraps on mobile */}
              <p className="text-base sm:text-xl md:text-2xl lg:text-3xl font-bold text-[#4D4D4D] leading-relaxed">
                "Because every <span className="text-primary-blue">GENIUS</span> was once called an <span className="text-primary-blue">IDIOT</span>"
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Animations */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
          opacity: 0;
        }

        .delay-300 {
          animation-delay: 0.3s;
        }

        .delay-600 {
          animation-delay: 0.6s;
        }

        .delay-900 {
          animation-delay: 0.9s;
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        .animate-pulse {
          animation: pulse 2s ease-in-out infinite;
        }
      `}
      </style>
    </div>
  );
}
